import { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useToastContext } from "components/alert/ToastContext";
import NotaFiscalSaidaDocumento from "model/vendas/NotaFiscalSaidaDocumento";
import NotaFiscalSaidaService from "service/vendas/NotaFiscalSaidaService";

const service = new NotaFiscalSaidaService();
const tipos: Record<NotaFiscalSaidaDocumento["tipoDocumento"], string> = {
    XML_GERADO: "Gerado", XML_ASSINADO: "Assinado", XML_AUTORIZADO: "Autorizado", XML_EVENTO_ASSINADO:"Evento assinado", XML_EVENTO_PROCESSADO:"Evento registrado", DANFE:"DANFE", PDF_CCE:"Carta de correção (PDF)"
};

export default function NotaFiscalSaidaDocumentos({ idNota }: { idNota: number }) {
    const [documentos, setDocumentos] = useState<NotaFiscalSaidaDocumento[]>([]);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState(false);
    const [revisao, setRevisao] = useState(0);
    const [baixando, setBaixando] = useState<number | null>(null);
    const { msgErro } = useToastContext();

    useEffect(() => {
        let ativo = true;
        setCarregando(true);
        setErro(false);
        setDocumentos([]);
        service.listarDocumentos(idNota)
            .then(lista => { if (ativo) setDocumentos(lista); })
            .catch(() => { if (ativo) setErro(true); })
            .finally(() => { if (ativo) setCarregando(false); });
        return () => { ativo = false; };
    }, [idNota, revisao]);

    async function baixar(documento: NotaFiscalSaidaDocumento) {
        if (baixando !== null) return;
        setBaixando(documento.id);
        try {
            const arquivo = await service.baixarDocumentoHistorico(idNota, documento.id);
            saveAs(arquivo, `nfe-${documento.chaveAcesso}-v${documento.versao}-${documento.tipoDocumento.toLowerCase()}.${["DANFE","PDF_CCE"].includes(documento.tipoDocumento)?"pdf":"xml"}`);
        } catch {
            msgErro("XML da NF-e", "Não foi possível baixar o XML ou confirmar a integridade do arquivo.");
        } finally {
            setBaixando(null);
        }
    }

    return <div>
        <p>O histórico preserva XMLs, eventos registrados e PDFs de cada versão da nota. XML gerado ou assinado não comprova autorização de uso.</p>
        <Button label="Atualizar documentos" icon="pi pi-refresh" outlined disabled={carregando}
            onClick={() => setRevisao(anterior => anterior + 1)} className="mb-3" />
        {erro ? <p role="alert">Não foi possível carregar o histórico de XMLs. Tente novamente.</p> :
            <DataTable value={documentos} loading={carregando} emptyMessage="Nenhum XML registrado para esta nota" responsiveLayout="scroll">
                <Column field="versao" header="Versão" />
                <Column header="Documento" body={(documento: NotaFiscalSaidaDocumento) => tipos[documento.tipoDocumento]} />
                <Column header="Registrado em" body={(documento: NotaFiscalSaidaDocumento) => new Date(documento.dataCriacao).toLocaleString("pt-BR")} />
                <Column header="Ações" body={(documento: NotaFiscalSaidaDocumento) =>
                    <Button label="Baixar" icon="pi pi-download" outlined loading={baixando === documento.id}
                        disabled={baixando !== null} onClick={() => { void baixar(documento); }} />} />
            </DataTable>}
    </div>;
}
